import { render, staticRenderFns } from "./PagamentoStatus.vue?vue&type=template&id=1672dc0c"
import script from "./PagamentoStatus.vue?vue&type=script&lang=js"
export * from "./PagamentoStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports